import "./../styles.scss";

import React from "react";
import Modal from "react-modal";

import amplitude from "../../../externals/amplitude";

const DeleteFolder = ({ ...props }) => {
  const { deleteModalOpen, setDeleteModalOpen, folderDetails, getFolder, costumFields, id } = props;
  const closeModel = () => {
    setDeleteModalOpen(false);
  };
  //Delete FOlder
  const deleteFolder = () => {
    const payload = {
      folder: {
        name: folderDetails.name,
        _id: folderDetails?._id,
      },
      settingId: costumFields?._id,
      action: "delete",
      entityId: id,
    };
    getFolder(payload);
    closeModel();
    amplitude.logEvent("folder_deleted", { folder: folderDetails?.name, folder_id: folderDetails?._id });
  };

  return (
    <>
      <Modal
        isOpen={deleteModalOpen}
        ariaHideApp={false}
        onRequestClose={closeModel}
        contentLabel="Delete Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        shouldCloseOnOverlayClick={false}
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Delete</h5>
          </div>
          <div className="react-modal-body text-center">
            <h6 className="react-modal-body-text">Are you sure you want to delete?</h6>
          </div>
          <div className="react-modal-footer text-center">
            <div className="react-foo-container">
              <button type="button" onClick={closeModel} className="btn btn-white">
                Close{" "}
              </button>
              <button type="button" onClick={() => deleteFolder()} className="btn btn-primary">
                Delete
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DeleteFolder;
